<div *ngIf="renderedContent" class="w-100 position-relative">
  @if (isFlipped) {
    <div class="h-100 w-100 is-vertical-align align-items-flex-start is-horizontal-align pl-3">
      @if (secureCVVDetails.pan && secureCVVDetails.cvv2 && secureCVVDetails.expDate) {
        <div class="position-absolute card-details">
          <div class="mb-4 d-flex">
            <div [ngStyle]="backCardTextStyles.details">{{ secureCVVDetails.pan }}</div>
            <finxone-web-frontend-copy-share
              [textContentTemplate]="''"
              [leftIcon]="'mat_copy'"
              [copyContentTemplate]="secureCVVDetails.pan"
              (copyContentValue)="copyContent($event, CardsSuccessCodes.CARD_NUMBER_COPIED)"
              class="ml-1"
            ></finxone-web-frontend-copy-share>
          </div>
          <div class="d-flex">
            <div class="mr-5 d-flex" style="align-items: baseline">
              <div [ngStyle]="backCardTextStyles.label" class="back-text">VALID THRU</div>
              <div [ngStyle]="backCardTextStyles.details" class="ml-1 back-text">
                {{ secureCVVDetails.expDate }}
              </div>
            </div>
            <div class="d-flex" style="align-items: baseline">
              <div [ngStyle]="backCardTextStyles.label" class="back-text">CVC</div>
              <div [ngStyle]="backCardTextStyles.details" class="ml-1 back-text">
                {{ secureCVVDetails.cvv2 }}
              </div>
            </div>
          </div>
        </div>
        <div class="d-contents w-100 flipped-template" [innerHTML]="flippedCardTemplate | safeHtml"></div>
      } @else {
        <div class="position-absolute">
          <finxone-web-frontend-text-skeleton contentClass="skeleton_75 mb-4 h-[2em] rounded-[5px]" />
          <div class="d-flex gap-2">
            <finxone-web-frontend-text-skeleton contentClass="skeleton_50 mb-4 h-[2em] rounded-[5px]" />
            <finxone-web-frontend-text-skeleton contentClass="skeleton_50 mb-4 h-[2em] rounded-[5px]" />
          </div>
        </div>
        <div class="d-contents w-100 flipped-template" [innerHTML]="flippedCardTemplate | safeHtml"></div>
      }
    </div>
  } @else {
    <div
      class="d-contents w-100"
      [innerHTML]="renderedContent | safeHtml"
      (click)="onTemplateClick($event)"
    ></div>
    <div
      class="frozen-overlay"
      *ngIf="cardDetails?.status === CardStatusType.FROZEN && frozenOverlayContent"
      [innerHTML]="frozenOverlayContent | safeHtml"
    ></div>
  }
</div>
<div *ngIf="!renderedContent && !isFlipped">Card Component</div>
